<template>
  <div>
    <BankMain/>
  </div>
</template>

<script>
import BankMain from '@/components/Settings/BankMain'

export default {
  components: {
    BankMain
  },
  created: async function () {
    await this.$store.dispatch('bank/fetchBank')
    this.$store.dispatch('bank/resetAttrs')
  }
}
</script>
